<script setup lang="ts">
import { Icon } from '@engage-web-ui/icon';

export type Props = {
  tag?: string;
  icon: string;
  iconColour?: string;
  title?: string;
  text?: string;
};

defineProps<Props>();
</script>

<template>
  <div class="icon-box">
    <span v-if="tag" class="icon-box__tag">{{ tag }}</span>
    <Icon class="icon-box__icon" :icon="icon" :style="{ color: iconColour }" />
    <h3 class="icon-box__title">
      <slot name="title">{{ title }}</slot>
    </h3>
    <slot name="text">
      <p class="icon-box__text">
        {{ text }}
      </p>
    </slot>

    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
@use '../assets/styles/_globals.scss' as g;

.icon-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
  border: 1px solid light-dark(var(--p-neutral-200), var(--p-neutral-800));
  box-shadow: 0.5rem 0.5rem 1rem
    color-mix(in srgb, light-dark(var(--p-surface-900), var(--p-surface-0)) 4%, transparent);
  border-radius: 0.25rem;
  padding: 1.5rem;

  &__tag {
    position: absolute;
    top: 1.5rem;
    right: 2rem;
    padding: 0.5rem 1rem;
    background: light-dark(var(--p-slate-200), var(--p-slate-700));
    font-size: 0.8rem;
    font-weight: 600;
    border-radius: 1rem;
  }

  &__icon {
    font-size: 1.5rem;
  }

  &__title {
    font-size: 1.5rem;
    font-weight: 800;
  }
}
</style>
